import {
  Dialog,
  DialogActions,
  DialogContent,
  DialogContentText,
  DialogTitle,
} from '@mui/material';
import React from 'react';
import { useQueryClient } from 'react-query';
import { useDeclineRetentionRuleMutation } from 'src/graphql';
import { LensButton } from '../LensButton';

interface DeleteRuleDialogProps {
  ruleId: string;
  open: boolean;
  onClose: () => void;
}

export const DeleteRuleDialog: React.FC<DeleteRuleDialogProps> = ({
  ruleId,
  open,
  onClose,
}) => {
  const queryClient = useQueryClient();

  const { mutate: declineRule } = useDeclineRetentionRuleMutation({
    onSuccess: () => {
      queryClient.invalidateQueries('GetRetentionRules');
      queryClient.invalidateQueries('GetFallbackRetentionRules');
      queryClient.invalidateQueries('GetRetentionRulesCount');
      onClose();
    },
    onError: (error) => console.error('Failed to delete rule:', error),
  });

  return (
    <Dialog open={open} onClose={onClose}>
      <DialogTitle>Delete rule</DialogTitle>
      <DialogContent>
        <DialogContentText>
          Are you sure you want to delete this rule? This action cannot be
          undone.
        </DialogContentText>
      </DialogContent>
      <DialogActions>
        <LensButton variant="secondary" buttonSize="small" onClick={onClose}>
          Cancel
        </LensButton>
        <LensButton
          variant="danger"
          buttonSize="small"
          onClick={() => declineRule({ input: { id: ruleId } })}
        >
          Delete
        </LensButton>
      </DialogActions>
    </Dialog>
  );
};
